
import request from '@/utils/request';
import { get, post } from '@/utils/request';

export function login(username, password){
  return post('/user/login', {
    username,
    password
  });
}

export function getInfo(){
  return post('/user/info');
}

export function logout(usertoken){
  return request({
    url: '/user/logout',
    method: 'post',
    data:{usertoken}
  });
}

export function getCode(data){
  return post('/connect/getCode', data);
}
export function register(data) {
  return post('/user/register',data)
}

export function reset(old_pass ,user_pass){
	return post('/user/reset', {
		old_pass,
		user_pass,
	});
}



// WEBPACK FOOTER //
// ./src/api/user.js